import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MasterService } from 'src/app/pages/master/master.service';

@Component({
  selector: 'app-modal-change-driver-attributes',
  templateUrl: './modal-change-driver-attributes.component.html',
})
export class ModalChangeDriverAttributesComponent implements OnInit {
  @Input() modalTitle: string = '';
  @Input() modalQuestion: string = '';
  @Input() modalMessage: string = '';
  @Input() valueToEdit: string = '';
  @Input() attributeForm: FormGroup = new FormGroup({});
  @Output() modalDismissed: EventEmitter<string> = new EventEmitter<string>();
  @Output() modalClosed: EventEmitter<string> = new EventEmitter<string>();

  readonly master: any = {};
  editableLabel: string = '';
  editableOpts: Array<any> = [];

  constructor(private masterService: MasterService) {
    this.master = this.masterService.getMaster();
  }
  ngOnInit(): void {
    switch (this.valueToEdit) {
      case 'accreditationType':
        this.editableOpts = this.master['DRIVERS#ACCREDITATION_TYPES'];
        this.editableLabel = '';
        break;
      case 'assignmentType':
        this.editableOpts = this.master['DRIVERS#ASSIGNMENT_TYPES'];
        this.editableLabel = '';
        break;
      case 'group':
        this.editableOpts = this.master['DRIVERS#DRIVER_GROUPS'];
        break;
      default:
        this.editableOpts = this.master['DRIVERS#DRIVER_GROUPS'];
        break;
    }
  }
  /**
   * Función de desecho del modal.
   * @param {string} value Tecla con que fue desechado.
   */
  d(value: string): void {
    this.modalDismissed.emit(value);
  }

  /**
   * Función de cierre del modal.
   * @param {string} value Tecla con que fue cerrado.
   */
  c(value: string): void {
    this.modalClosed.emit(value);
  }
}
